// Dependencies
import React, { createClass } from 'react';
import Icon from '../../../tc-ui/icon';
import TypeAheadInputAndDropdown from './typeahead-input-and-dropdown-container';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';

const ConnectionsTagsTypeAhead = createClass({

  getInitialState() {
    return {
      typeAheadDropDownOpen: false,
    };
  },

  toggleTypeAheadDropDown() {
    this.setState({ typeAheadDropDownOpen: !this.state.typeAheadDropDownOpen }, () => {
      // document.getElementById('type-ahead-input').focus();
    });
  },

  componentClickAway() {
    if (this.state.typeAheadDropDownOpen) this.toggleTypeAheadDropDown();
  },

  render() {
    return (
      <ClickAwayListener onClickAway={this.componentClickAway}>
        <div>
          <TypeAheadInputAndDropdown { ...this.props } open={this.state.typeAheadDropDownOpen} />
          <Icon className="connections-typeahead-tag-icon tc-icon-arrow-drop-down" onClick={this.toggleTypeAheadDropDown} />
        </div>
      </ClickAwayListener>
    );
  },
});

export default ConnectionsTagsTypeAhead;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-tags-modal/connections-tags-typeahead/typeahead.jsx